export const normalizeSearchProductRouteIdentifier = (value) => {
  const identifier = Array.isArray(value) ? value[0] : value;
  if (identifier === null || identifier === undefined) return null;

  const normalized = String(identifier).trim();
  if (!normalized || normalized === 'null' || normalized === 'undefined') return null;
  return normalized;
};

const isIntegratedSearchPath = (path) => /^\/search$/i.test(path);

export const isSearchProductDetailPath = (path) =>
  /^\/search\/product\/[^/]+\/[^/]+$/i.test(path);

export const shouldClearSearchProductOrigin = (toPath, originPath) => {
  const originMatch = originPath?.match(/^\/search\/product\/([^/]+)\/[^/]+$/i);
  if (!originMatch || isSearchProductDetailPath(toPath)) return false;

  const destinationStoreMatch = toPath?.match(/^\/shop\/([^/]+)(?:\/|$)/i);
  return !destinationStoreMatch || destinationStoreMatch[1] !== originMatch[1];
};

export const shouldKeepSearchProductCache = (toPath, fromPath) =>
  isIntegratedSearchPath(toPath) ||
  (isIntegratedSearchPath(fromPath) && isSearchProductDetailPath(toPath));
